import { render, staticRenderFns } from "./LiquidacaoFiltro.vue?vue&type=template&id=35388012&"
import script from "./LiquidacaoFiltro.vue?vue&type=script&lang=js&"
export * from "./LiquidacaoFiltro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports